import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SubscriptionTypeEnum } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/models/enum/SubscriptionTypeEnum';
import { SubscriptionHistory } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/models/subscribers/SubscriptionHistory';
import { MemberSubscrpitionHistoryService } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/services/connect/member-subscrpition-history.service';

@Component({
  selector: 'app-subscription-history',
  standalone: false,
  templateUrl: './subscription-history.component.html'
})
export class SubscriptionHistoryComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();
  dataLoading = false;
  dataSource: SubscriptionHistory = new SubscriptionHistory();
  subscriptionTypeEnum = SubscriptionTypeEnum

  constructor(private memberSubscrpitionHistoryService: MemberSubscrpitionHistoryService) {

  }

  ngOnInit() {
    this.getSubscriptionHistory();
  }

  getSubscriptionHistory() {
    this.dataLoading = true;
    this.memberSubscrpitionHistoryService.getMemberSubscriptionHistoriesForMemberUser().subscribe(
      (res: any) => {
        this.dataLoading = false;
        this.dataSource = res;
      },
      (err:any) => {
        this.dataLoading = false;
        console.log(err);
      }
    );
  }

}
